module.exports = __webpack_public_path__ + "img/mitsu02.ca46c98a.png";